import styled from 'styled-components';
import { SIZE, FONTS } from '@app/src/ui';

interface Props {
  bgColor?: string;
}

export const Reserved = styled.div`
  background: ${(props: Props) => props.bgColor || '#000'};
  font-size: 12px;
  font-family: ${FONTS.OPEN_SANS};
  text-align: center;
  color: #666;

  @media (min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 14px;
  }
`;
